import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-end;

  position: fixed;
  top: 90px;
  right: -200px;
  z-index: 1;

  width: 250px;

  ${props => props.theme.old.is.isTabLand}{
    margin-top: 16px;
    gap: 8px;
  }

  ${({ theme }) => theme.old.breakpoints.isMobile}{
    top: 150px;
  }
`;


